import React, {Component} from 'react';
import {connect} from 'react-redux';
import {CheckCircleTwoTone, DownOutlined, ExclamationCircleTwoTone} from '@ant-design/icons';
import {List, Popover, Spin} from 'antd';
import Big from 'big.js';
import StockBalanceActions from 'bukku/redux/StockBalance/actions';
import {t} from "@lingui/macro";

const {readStockBalance} = StockBalanceActions;

class Quantity extends Component {
    mapping = {
        outOfStock: {title: t`Out of Stock`, statusIcon: <ExclamationCircleTwoTone twoToneColor="#eb2f96" />},
        lowInStock: {title: t`Low in Stock`, statusIcon: <CheckCircleTwoTone twoToneColor="#ffa940" />},
        inStock: {title: t`In Stock`, statusIcon: <CheckCircleTwoTone twoToneColor="#52c41a" />},
        noIcon: {title: null, statusIcon: null},
    };

    constructor(props) {
        super(props);
        this.state = {
            isLoading: true,
            stockBalances: [],
        };
    }

    shouldComponentUpdate(nextProps) {
        const {readStockBalanceState, requestedProductId, productId} = this.props;
        if (readStockBalanceState !== nextProps.readStockBalanceState && requestedProductId !== productId)
            return false;

        return true;
    }

    componentDidUpdate(prevProps) {
        const {readStockBalanceState, stockBalances, requestedProductId, productId} = this.props;
        if (readStockBalanceState === 'success' && prevProps.readStockBalanceState === 'request' &&
        requestedProductId === productId) {
            this.setState({
                isLoading: false,
                stockBalances,
            });
        }
    }

    getDp = amount => {
        // 4dp or 2dp
        const objAmount = new Big(amount);
        const objDiff = objAmount.minus(objAmount.toFixed(2)).abs();

        return (!objDiff.eq(0)) ? 4 : 2;
    };

    renderIcon = () => {
        const {amount, noIcon, lowTrigger} = this.props;

        // 4dp or 2dp
        const objAmount = new Big(amount);

        if (noIcon)
            return this.mapping.noIcon;
        if (objAmount.lte(0))
            return this.mapping.outOfStock;
        if (lowTrigger && objAmount.cmp(lowTrigger) === -1)
            return this.mapping.lowInStock;
        return this.mapping.inStock;
    };

    onVisibleChange = bool => {
        const {readStockBalance, productId} = this.props;
        const {isLoading} = this.state;
        if (bool) {
            // FETCHING DATA
            // console.log("Fetching Data")
            if (isLoading)
                this.setState({isLoading: true, stockBalances: []});

            readStockBalance(productId);
        }
    };

    formatNumber = (amount, decimals) => (
        parseFloat(amount)
            .toFixed(decimals)
            .replace(/\d(?=(\d{3})+\.)/g, '$&,')
    );

    renderPopoverContent = () => {
        const {isLoading, stockBalances} = this.state;
        return (
            <Spin spinning={isLoading}>
                <List
                    size="small"
                    dataSource={stockBalances}
                    renderItem={item => {
                        const dp = this.getDp(item.balance);
                        return (
                            <List.Item>
                                <div className="container">
                                    <div className="text-container">
                                        <strong className="code">{item.code}</strong>
&nbsp;&nbsp;
                                        <span className="name">{item.name}</span>
                                    </div>
                                    <span className="qty">{this.formatNumber(item.balance, dp)}</span>
                                </div>
                            </List.Item>
                        );
                    }}
                />
            </Spin>
        );
    };

    render() {
        const {
            amount,
        } = this.props;

        if (amount === null || amount === undefined || amount === '')
            return '-';

        const dp = this.getDp(amount);
        const {title, statusIcon} = this.renderIcon();

        // StockBalanceBreakdownIcon
        return (
            <Popover
                overlayClassName="stock-transfer-popover"
                placement="bottom"
                trigger="click"
                // arrowPointAtCenter
                arrow={{pointAtCenter: true}}
                title={(
                    <>
                        {title}
                        &nbsp;
                        {statusIcon}
                    </>)}
                content={this.renderPopoverContent}
                onOpenChange={this.onVisibleChange}
            >
                <div style={{cursor: 'pointer'}}>
                    {this.formatNumber(amount, dp)}
                    &nbsp;
                    {statusIcon}
                    &nbsp;
                    <DownOutlined
                        style={{fontSize: 10, color: '#00000050'}}
                    />
                </div>
            </Popover>
        );
    }
}

export default connect(state => ({
    readStockBalanceState: state.StockBalance.readStockBalanceState,
    stockBalances: state.StockBalance.stockBalances,
    requestedProductId: state.StockBalance.requestedProductId,
}), {
    readStockBalance,
})(Quantity);
